import ObservableState from './common/ObservableState'

export default ObservableState.create(0)
